import { PublicRouteType } from '../types/common';
import Sidebar from '../layouts/Sidebar';
import styles from '../layouts/Layouts.module.scss';

const PublicRoute = ({ children }: PublicRouteType) => {
  return (
    <>
    <div style={{display: 'flex'}}>
      <Sidebar />
      <div className={styles.layoutContainer}>
        {children}
      </div>
    </div>
    </>
  );
};

export default PublicRoute;
